// Mock data for Rapide Colis

export const mockPackages = [
  {
    trackingNumber: "RC2024001",
    status: "En transit",
    origin: "Paris",
    destination: "Abidjan",
    currentLocation: "En route vers Abidjan",
    estimatedDelivery: "2024-12-20",
    history: [
      { date: "2024-12-18 10:30", location: "Paris", event: "Colis récupéré" },
      { date: "2024-12-18 14:00", location: "Paris CDG", event: "En transit" },
      { date: "2024-12-19 08:00", location: "En vol", event: "En cours d'acheminement" }
    ]
  },
  {
    trackingNumber: "RC2024002FR",
    status: "Livré",
    origin: "Abidjan",
    destination: "Paris",
    currentLocation: "Paris - Château d'eau",
    estimatedDelivery: "2024-12-18",
    history: [
      { date: "2024-12-16 09:00", location: "Abidjan", event: "Colis récupéré" },
      { date: "2024-12-17 06:00", location: "En vol", event: "En transit" },
      { date: "2024-12-18 11:00", location: "Paris", event: "Livré" }
    ]
  },
  {
    trackingNumber: "RC2024003CI",
    status: "En attente",
    origin: "Paris",
    destination: "Abidjan",
    currentLocation: "Paris - Château d'eau",
    estimatedDelivery: "2024-12-21",
    history: [
      { date: "2024-12-19 15:00", location: "Paris", event: "En attente d'expédition" }
    ]
  }
];

export const services = [
  {
    id: 1,
    name: "Vêtements",
    icon: "Shirt",
    description: "Transport sécurisé de vos vêtements"
  },
  {
    id: 2,
    name: "Cosmétiques",
    icon: "Sparkles",
    description: "Produits de beauté et cosmétiques"
  },
  {
    id: 3,
    name: "Électronique",
    icon: "Smartphone",
    description: "Appareils électroniques avec protection"
  },
  {
    id: 4,
    name: "Électroménager",
    icon: "Tv",
    description: "Appareils électroménagers volumineux"
  },
  {
    id: 5,
    name: "Nourritures",
    icon: "UtensilsCrossed",
    description: "Produits alimentaires non périssables"
  },
  {
    id: 6,
    name: "Outils et matériels",
    icon: "Wrench",
    description: "Équipements professionnels"
  },
  {
    id: 7,
    name: "Documents",
    icon: "FileText",
    description: "Envoi sécurisé de documents"
  },
  {
    id: 8,
    name: "Autres",
    icon: "Package",
    description: "Et bien d'autres articles"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Livraison rapide",
    description: "Vos colis livrés en 48h entre Paris et Abidjan",
    icon: "Zap"
  },
  {
    id: 2,
    title: "Fiabilité",
    description: "Service de confiance avec suivi en temps réel",
    icon: "Shield"
  },
  {
    id: 3,
    title: "Sécurité",
    description: "Protection maximale de vos colis",
    icon: "Lock"
  },
  {
    id: 4,
    title: "Service client WhatsApp",
    description: "Support disponible 7j/7 via WhatsApp",
    icon: "MessageCircle"
  }
];

export const contactInfo = {
  paris: {
    address: "24 boulevard de Strasbourg",
    details: "Château d'eau, salon de coiffure (ESPACE BEAUTE)",
    postalCode: "75010 Paris",
    whatsapp: ["+33695701735", "+33758627879"]
  },
  abidjan: [
    {
      location: "Plateau Dokui 1er Arrêt Bus",
      whatsapp: "+2250713190304"
    },
    {
      location: "Plateau Dokui Mahou",
      whatsapp: "+2250779706497"
    },
    {
      location: "Adjamé St Michel",
      whatsapp: "+2250714981573"
    },
    {
      location: "Yopougon Wassakara",
      whatsapp: "+2250713806040"
    }
  ]
};
